import * as React from "react";
import { useCallback, useMemo } from "react";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import usePluginEntities from "hooks/usePluginEntities";
import { Select } from "components/common";
import { Input } from "components/bootstrap";
import { useFetchDataAdapterTypes } from "components/lookup-tables/hooks/useLookupTablesAPI";
function AdapterTypeSelect({ adapterConfigType, onAdapterChange }) {
  const { types, fetchingDataAdapterTypes } = useFetchDataAdapterTypes();
  const plugins = usePluginEntities("lookupTableAdapters");
  const adapterPlugins = Object.fromEntries(plugins.map((p) => [p.type, p]));
  const sortedAdapters = useMemo(() => {
    if (!fetchingDataAdapterTypes) {
      return Object.keys(types).map((key) => {
        const typeItem = types[key];
        if (!adapterPlugins[typeItem.type]) {
          console.error(
            `Plugin component for data adapter type ${typeItem.type} is missing - invalid or missing plugin?`
          );
          return {
            value: typeItem.type,
            disabled: true,
            label: `${typeItem.type} - missing or invalid plugin`
          };
        }
        return {
          value: typeItem.type,
          label: adapterPlugins[typeItem.type].displayName
        };
      }).sort((a, b) => naturalSort(a.label.toLowerCase(), b.label.toLowerCase()));
    }
    return [];
  }, [types, fetchingDataAdapterTypes, adapterPlugins]);
  const _getCorrectUserpasswd = (config) => {
    if (config.user_passwd.is_set) return { is_set: true, keep_value: true };
    return { set_value: "" };
  };
  const handleTypeSelect = useCallback(
    (adapterType) => {
      const defaultConfig = { ...types[adapterType].default_config };
      const isLDAP = defaultConfig.type === "LDAP";
      const configWithPassword = {
        ...defaultConfig,
        ...isLDAP ? { user_passwd: _getCorrectUserpasswd(defaultConfig) } : {}
      };
      onAdapterChange({
        id: null,
        title: "",
        name: "",
        description: "",
        config: configWithPassword
      });
    },
    [onAdapterChange, types]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "data-adapter-type-select",
      label: "Data Adapter Type",
      required: true,
      help: "The type of data adapter to configure."
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: "Select Data Adapter Type",
        clearable: false,
        options: sortedAdapters,
        onChange: handleTypeSelect,
        value: adapterConfigType
      }
    )
  );
}
export default AdapterTypeSelect;
